module.exports = __webpack_public_path__ + "static/turkeysub-067d54e4d5109807b5c4ab5d171cea01.jpg";